import { LOCIZE_NS, MUTATION_KEYS } from '@avanta/shared/constants/common';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { FileService } from 'services/files';
import { type Appointment } from 'types/appointments';
import { type Report } from 'types/files';
import { openReportPdf } from 'utils/storage';

export const useViewSessionReport = (): UseMutationResult<
  AxiosResponse<Report[]>,
  AxiosError,
  Pick<Appointment, 'id'>
> => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return useMutation({
    mutationKey: [MUTATION_KEYS.DOWNLOAD_ENTERPRISE_SESSION_REPORT],
    mutationFn: async (appointment: Pick<Appointment, 'id'>) =>
      FileService.getReportsByAppointment(appointment.id),
    onSuccess: async response => {
      const report = response.data.find(item => Boolean(item.pdf));

      if (!report) {
        toast.info(t('SessionsPage.viewReport.empty'));
        return;
      }

      await openReportPdf(report);
    },
  });
};
